export const ExemptedPaths = {
    HOMEPAGE: '/',
    LOGIN: '/login',
}
